import React from 'react';
import PropTypes from 'prop-types';

import './style.sass';
import ModalView from '../modalView';

const CreateTaskModal = (props) => {
  const { t } = props;
  return (
    <ModalView
      dateFormat="dd MM yyyy"
      modalTitle={t('Create new task')}
      action={t('Create')}
      name="createTaskModal"
      {...props}
    />
  );
};

CreateTaskModal.propTypes = {
  t: PropTypes.func.isRequired,
};

export default CreateTaskModal;
